import IService from "./service";

export default class SubmissionsService extends IService {

    async getSubmission(submission) {
        return await this.$services.api.get('submissions/' + submission.id);
    }
}
